var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup-loader"},[_c('img',{staticClass:"img-fluid popup-loader__image",attrs:{"src":"/images/ui/bluto-loader.svg","width":"50","height":"50","alt":"Loading..."}})])
}]

export { render, staticRenderFns }